/** The build's release (vite.config.ts), shown at the navigation's foot and named in error reports. */
export const RELEASE = String(import.meta.env.VITE_RELEASE ?? '')
  .replace(/[^A-Za-z0-9_.-]/g, '')
  .slice(0, 100)
